<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-body">
                    <div class="form-floating mb-2">
                        <input class="form-control" id="admin-login" type="text" v-model="formData.login">
                        <label for="admin-login">Логин пользователя</label>
                    </div>
                    <div class="form-floating mb-2">
                        <input class="form-control" id="admin-email" type="text" v-model="formData.email">
                        <label for="admin-email">Почта</label>
                    </div>
                    <div class="form-floating mb-2">
                        <input class="form-control" id="admin-phone" type="text" v-model="formData.mobile_phone">
                        <label for="admin-phone">Номер телефона</label>
                    </div>
                    <div class="mb-2">
                        <label for="admin-group">Группа</label>
                        <select class="form-select" id="admin-group" v-model="formData.group_id">
                            <option v-for="group in groups" :value="group.id">{{group.name}}</option>
                        </select>
                    </div>
                    <div class="mb-2">
                        <label for="admin-client">Прикрепленный клиент</label>
                        <select class="form-select" id="admin-client" v-model="formData.client_id">
                            <option disabled value="0">Без клиента</option>
                            <option v-for="client in clients" :value="client.id">{{client.name}}</option>
                        </select>
                    </div>
                    <div class="form-floating mb-2">
                        <input class="form-control" id="admin-name" type="text" v-model="formData.name">
                        <label for="admin-name">Имя</label>
                    </div>
                    <div class="form-floating mb-2">
                        <input class="form-control" id="admin-surname" type="text" v-model="formData.surname">
                        <label for="admin-surname">Фамилия</label>
                    </div>
                    <div class="form-floating mb-2">
                        <input class="form-control" id="admin-patronymic" type="text" v-model="formData.patronymic">
                        <label for="admin-patronymic">Отчество</label>
                    </div>
                    <div class="mb-3">
                        <label for="admin-comment" class="form-label">Комментарий</label>
                        <textarea class="form-control" id="admin-comment" rows="3" v-model="formData.comment"></textarea>
                    </div>
                </div>
                <div>
                    <button v-if="createElement" class="btn btn-success m-1" v-on:click="create()">
                        Создать
                    </button>
                    <button v-else class="btn btn-success m-1" v-on:click="edit()">
                        Изменить
                    </button>
                    <button class="btn btn-danger" v-on:click="closeModal">
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "AdminUserModal",
    props: {
        requestUrl: {
            type: String,
            default: 'empty'
        },
        createElement: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 0
        },
        view_data: {
            type: Object,
            default: {}
        },
        groups: {
            type: [Array, Object],
            default: []
        },
        clients: {
            type: [Array, Object],
            default: []
        }
    },
    emits: ["insert", "closeModal", "edit"],
    data: function () {
        return {
            formData: {
                login: '',
                email: false,
                mobile_phone: '',
                group_id: 0,
                client_id: 0,
                name: '',
                surname: '',
                patronymic: ''
            }
        }
    },
    watch: {
        view_data: {
            handler(newValue){
                this.formData = {...newValue};
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        create: function () {
            this.$emit('insert', this.formData);
        },
        closeModal: function() {
            this.$emit('closeModal');
        },
        edit: function () {
            this.$emit('edit', this.formData, this.id);
        },

    },
    mounted() {
        if(this.createElement)
        {
            this.formData.client_id = 0;
            this.formData.group_id = 5;
        }
    }
}
</script>

<style scoped>

</style>
